/* v6 — Bothé — (1) cycle vidéo sur les CARTES produit (accueil + collections),
   (2) FIX mobile galerie produit : la vidéo position 2 se lance au swipe, pause en sortant,
   (3) v5.2 : vidéos galerie sans contrôles natifs (cleanVideo défensif),
   (4) v5.3 : SAUVETAGE AUTOPLAY GLOBAL — toute vidéo [autoplay] (dont les vidéos des
   descriptions produit) relancée au premier geste si iOS mode éco a bloqué l'autoplay.
   NB: throttle par setTimeout (PAS de requestAnimationFrame — ne fire pas dans certains
   contextes, même leçon que l'IntersectionObserver). */
(function () {
  function cleanVideo(v) {
    if (!v) return;
    v.muted = true;
    v.defaultMuted = true;
    v.playsInline = true;
    v.setAttribute('playsinline', '');
    v.setAttribute('muted', '');
    v.loop = true;
    v.removeAttribute('controls');
    v.controls = false;
    v.disablePictureInPicture = true;
    v.setAttribute('disablepictureinpicture', '');
  }

  function init() {
    /* v6 — vidéos cartes : au SURVOL uniquement (desktop souris). Sur mobile/tactile,
       l'image reste figée ; la cliente voit la vidéo en position 2 de la fiche produit. */
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches)) return;
    var vids = Array.prototype.slice.call(document.querySelectorAll('.bothe-card-video'));
    if (!vids.length) return;

    vids.forEach(function (v) {
      var card = v.closest('.card') || v.parentElement;
      if (!card) return;

      card.addEventListener('mouseenter', function () {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.loop = true;
        try { v.currentTime = 0; } catch (e) {}
        var p = v.play();
        if (p && p.then) {
          p.then(function () { v.classList.add('bothe-playing'); }).catch(function () {});
        } else {
          v.classList.add('bothe-playing');
        }
      });

      card.addEventListener('mouseleave', function () {
        v.classList.remove('bothe-playing');
        setTimeout(function () {
          if (!v.classList.contains('bothe-playing')) {
            v.pause();
            try { v.currentTime = 0; } catch (e) {}
          }
        }, 450);
      });
    });
  }

  function initMobileGallery() {
    if (!window.matchMedia || window.matchMedia('(min-width: 750px)').matches) return;
    var list = document.querySelector('.product__media-list');
    if (!list) return;
    var throttled = false;

    function check() {
      var items = list.querySelectorAll('.product__media-item');
      Array.prototype.forEach.call(items, function (item) {
        var dm = item.querySelector('deferred-media');
        if (!dm) return;
        var r = item.getBoundingClientRect();
        if (!r.width) return;
        var vw = window.innerWidth || document.documentElement.clientWidth;
        var px = Math.min(r.right, vw) - Math.max(r.left, 0);
        var mostlyVisible = px > r.width * 0.6;
        var video = dm.querySelector('video');
        if (mostlyVisible) {
          item.classList.add('is-active');
          if (!dm.hasAttribute('loaded') && typeof dm.loadContent === 'function') {
            dm.loadContent(false);
          }
          video = dm.querySelector('video');
          if (video) {
            cleanVideo(video);
            if (video.paused) {
              var p = video.play();
              if (p && p.catch) p.catch(function () {});
            }
          }
        } else if (video && !video.paused) {
          video.pause();
        }
      });
    }

    function onScroll() {
      if (throttled) return;
      throttled = true;
      setTimeout(function () {
        throttled = false;
        check();
      }, 150);
    }

    list.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setTimeout(check, 800);
  }

  function initGalleryCleanup() {
    var wrapper = document.querySelector('.product__media-wrapper');
    if (!wrapper) return;
    var mo = new MutationObserver(function () {
      Array.prototype.forEach.call(wrapper.querySelectorAll('deferred-media video'), cleanVideo);
    });
    mo.observe(wrapper, { childList: true, subtree: true });
    Array.prototype.forEach.call(wrapper.querySelectorAll('deferred-media video'), cleanVideo);
  }

  function initAutoplayRescue() {
    /* Toute vidéo marquée autoplay (hors cartes/galerie déjà gérées) doit tourner :
       iOS mode éco bloque l'autoplay → relance immédiate, à 1.2s, au premier geste
       (touch/click/scroll) et au retour sur l'onglet. */
    function tryPlayAll() {
      var allPlaying = true;
      var vids = document.querySelectorAll('video[autoplay]:not(.bothe-card-video)');
      Array.prototype.forEach.call(vids, function (v) {
        v.muted = true;
        v.defaultMuted = true;
        v.playsInline = true;
        v.setAttribute('playsinline', '');
        v.setAttribute('muted', '');
        if (v.paused) {
          allPlaying = false;
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        }
      });
      return allPlaying;
    }

    function onGesture() {
      if (tryPlayAll()) {
        ['touchstart', 'touchend', 'click', 'scroll'].forEach(function (evt) {
          window.removeEventListener(evt, onGesture);
        });
      }
    }

    tryPlayAll();
    setTimeout(tryPlayAll, 1200);
    ['touchstart', 'touchend', 'click', 'scroll'].forEach(function (evt) {
      window.addEventListener(evt, onGesture, { passive: true });
    });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) tryPlayAll();
    });
  }

  function boot() {
    init();
    initMobileGallery();
    initGalleryCleanup();
    initAutoplayRescue();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
